






import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class SimpleCheckBox extends Vue {
  @Prop()
  private title!: string;

  @Prop()
  private value!: any[];

  @Prop()
  private checked_result_value!: string;

  @Prop({ default: false })
  private disabled!: boolean;

  get result_value() {
    return this.checked_result_value ? this.checked_result_value : this.title;
  }

  get listModel(): any[] {
    return this.value;
  }

  set listModel(value: any[]) {
    this.$emit('input', value);
  }
}
